module.exports = __webpack_public_path__ + "assets/img/img86.5b72a341.png";